module.exports = __webpack_public_path__ + "img/Medusa_avatar.7b3b7b8a.png";